/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Empty_StateInputs */

const en_options_metadata_empty_state = /** @type {(inputs: Options_Metadata_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No metadata added yet. Add metadata information above to enhance your project.`)
};

const fr_options_metadata_empty_state = /** @type {(inputs: Options_Metadata_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune métadonnée ajoutée. Ajoutez des métadonnées ci-dessus pour enrichir votre projet.`)
};

const de_options_metadata_empty_state = /** @type {(inputs: Options_Metadata_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden noch keine Metadaten hinzugefügt. Fügen Sie oben Metadaten hinzu, um Ihr Projekt zu verbessern.`)
};

const it_options_metadata_empty_state = /** @type {(inputs: Options_Metadata_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun metadato ancora aggiunto. Aggiungi le informazioni sui metadati qui sopra per migliorare il tuo progetto.`)
};

const ru_options_metadata_empty_state = /** @type {(inputs: Options_Metadata_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные пока не добавлены. Добавьте информацию о метаданных выше, чтобы улучшить свой проект.`)
};

const es_options_metadata_empty_state = /** @type {(inputs: Options_Metadata_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no se han añadido metadatos. Añade la información de metadatos arriba para mejorar tu proyecto.`)
};

const zh_cn2_options_metadata_empty_state = /** @type {(inputs: Options_Metadata_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未添加元数据。请在上方添加元数据信息以完善您的项目。`)
};

const ja_options_metadata_empty_state = /** @type {(inputs: Options_Metadata_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータがまだ追加されていません。プロジェクトを強化するには、上記のメタデータ情報を追加してください。`)
};

const hi_options_metadata_empty_state = /** @type {(inputs: Options_Metadata_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक कोई मेटाडेटा नहीं जोड़ा गया है। अपने प्रोजेक्ट को बेहतर बनाने के लिए ऊपर मेटाडेटा जानकारी जोड़ें।`)
};

const pt_pt2_options_metadata_empty_state = /** @type {(inputs: Options_Metadata_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não foram adicionados metadados. Adicione informações de metadados acima para aprimorar seu projeto.`)
};

/**
* | output |
* | --- |
* | "No metadata added yet. Add metadata information above to enhance your project." |
*
* @param {Options_Metadata_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_empty_state = /** @type {((inputs?: Options_Metadata_Empty_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Empty_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metadata_empty_state(inputs)
	if (locale === "de") return de_options_metadata_empty_state(inputs)
	if (locale === "it") return it_options_metadata_empty_state(inputs)
	if (locale === "ru") return ru_options_metadata_empty_state(inputs)
	if (locale === "es") return es_options_metadata_empty_state(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metadata_empty_state(inputs)
	if (locale === "ja") return ja_options_metadata_empty_state(inputs)
	if (locale === "hi") return hi_options_metadata_empty_state(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metadata_empty_state(inputs)
	return en_options_metadata_empty_state(inputs)
});